/** @jsxImportSource @emotion/react */
import { Link } from "@mui/material";
import React, { useState,useContext } from "react";
import { Il8nContext } from '../../Helper/i18n';

let OTP_TIMEOUT = 5000;
const RESEND_LIMIT = 3;
let otpTimer = 0, resendCount = 0;
let timerId;

function ResendButton(props) {
    const { timeOut,isCaptchaVerified  ,setTimerCaptcha} = props;
    const localeText = useContext(Il8nContext)

    const classes = {
        clickable: {
            cursor: "pointer",
            fontSize: "14px",
        },
        disabledCursor: {
            cursor: "default",
            textDecoration: 'none',
        }
    }

    if (timeOut) {
        OTP_TIMEOUT = timeOut * 1000;
    }

    const [otpRemaining, setOtpRemaining] = useState(OTP_TIMEOUT / 1000);
    const [enabled, setEnabled] = useState(true);

    const checkTimeout = () => {
        if (otpTimer < OTP_TIMEOUT / 1000) {
            otpTimer++;
            setOtpRemaining(OTP_TIMEOUT / 1000 - otpTimer + 1);
        } else {
            setEnabled(true);
            clearInterval(timerId);
            setTimerCaptcha(false)
            timerId = null;
        }
    }

    const onResend = () => {
        const { onClick, onExceed } = props;
        if (resendCount < RESEND_LIMIT) {
                resendCount++;
                setEnabled(false);
                otpTimer = 0;
                startTimer();
            onClick && onClick();
        } else {
            onExceed && onExceed();
        }
    }

    const startTimer = () => {
        if (!timerId) {
            console.log('startTimer');
            timerId = setInterval(checkTimeout, 1000);
        }
    }

    // startTimer();

    return (enabled ?
        <Link key={otpRemaining} css={{float:"right", cursor: "pointer", margin:"5px 0px"}} className={classes.clickable} onClick={onResend}>{localeText?.landingResend}</Link>
        :
        <Link key={otpRemaining} css={{float:"right", margin:"5px 0px"}} underline='none' color='textSecondary' className={classes.disabledCursor}>{localeText?.landingResendIn} {otpRemaining}s</Link>
    );
}

export default ResendButton